/**
 * This component displays a resource image to the left and any of the children
 * passed to it on the right.
 *
 * ## Props
 *
 * ### Required
 *
 * `customIcon` or `image` : must supply either a valid rendering block or an image url.
 * If supplying `customIcon`, the resource is assumed to render itself as desired.
 * If supplying `image`, a url must be passed in for the image. An `altText` attribute
 * should be supplied unless the image is merely decorative [1]. An optional
 * `linkUrl` can be passed in to make the image a hyperlink, in which case
 * `altText` is mandatory; if not supplied, link will not be rendered.
 *
 *  [1] https://w.amazon.com/index.php/Goodreads/Engineering/Web/Accessibility
 *
 * ### Optional
 *
 * `imageClass` : an extra class to apply to the image
 */
import _ from "lodash";
import React from "react";
import GrComponentFactory from "../gr_component_factory";

export default GrComponentFactory.createClass({
  displayName: "SocialUpdateBody",

  propTypes: {
    customIcon: React.PropTypes.element,
    image: React.PropTypes.shape({
      altText: React.PropTypes.string,
      url: React.PropTypes.string.isRequired,
      linkUrl: React.PropTypes.string,
    }),
    imageClass: React.PropTypes.string,
  },

  getDefaultProps() {
    return { imageClass: "gr-socialUpdateBody__circleImage" };
  },

  hasAltText() {
    return !_.isEmpty(this.props.image.altText);
  },

  imgAltText() {
    if (this.hasAltText()) {
      return this.props.image.altText;
    } else {
      return "";
    }
  },

  renderImage() {
    if (this.props.customIcon) {
      return this.props.customIcon;
    } else {
      if (this.props.image.linkUrl && this.hasAltText()) {
        return <a href={this.props.image.linkUrl}>
                 {this.renderImageElement()}
               </a>;
      } else {
        return this.renderImageElement();
      }
    }
  },

  renderImageElement() {
    return <img alt={this.imgAltText()}
                className={this.props.imageClass}
                src={this.props.image.url} />;
  },

  render () {
    return (
      <div className="gr-mediaBox gr-socialUpdateBody">
        <div className="gr-socialUpdateBody__image gr-mediaBox__media">
          {this.renderImage()}
        </div>
        <div className="gr-mediaBox__desc gr-socialUpdateBody__additionalContent">
          {this.props.children}
        </div>
      </div>
    );
  },
});
